<div class="app-listbox"
     [class.edit]="editMode"
     [class.listboxMaterial]="isMaterial"
     *ngIf="items?.length > 0;else emptyMessageTemplate">
    <h5 *ngIf="label" [ngClass]="labelClass" [ngStyle]="labelStyle">{{ label }}</h5>
    <ng-container *ngIf="isLoading; then loading else content"></ng-container>
</div>


<ng-template #content>
    <p-listbox id="listbox"
               name="listbox"
               [options]="items"
               [formControl]="formControl"
               [multiple]="multiple">
        <ng-template
            *ngIf="custom"
            [pTemplate]="'item'"
            let-record>
            <ng-container
                *ngTemplateOutlet="custom; context: { $implicit: record }">
            </ng-container>
        </ng-template>

        <!-- Default templates -->
        <ng-template
            *ngIf="!custom"
            [pTemplate]="'item'"
            let-record>
            <div class="ui-helper-clearfix">
                <div [ngClass]="valueClass" [ngStyle]="valueStyle">
                    {{ record[displayField] }}
                </div>
            </div>
        </ng-template>
    </p-listbox>
</ng-template>


<ng-template #emptyMessageTemplate>
    <span>{{ emptyMessage | translate }}</span>
</ng-template>

<ng-template #loading>
    <app-loading-spinner></app-loading-spinner>
</ng-template>
